import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Server } from '../shared/models/server.model';
import { ServiceService } from '../shared/service/service.service';
import { User } from 'src/app/auth/user';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { EncryptionHandler } from '../../../auth/encryption-handler';

@Component({
  selector: 'app-server-form',
  templateUrl: './server-form.component.html',
  styleUrls: ['./server-form.component.scss']
})
export class ServerFormComponent implements OnInit {

  title: string = 'New Server';
  loggedInUser: any;
  loading: boolean = false;
  isVisible: boolean = false;

  serverForm = this.fb.group({
    id: [undefined],
    name: ['', [Validators.required]],
    environment: ['', [Validators.required]],
    url: ['', [Validators.required]],
    port: ['', [Validators.required]],
    user: ['', [Validators.required]],
    password: ['', [Validators.required]],
    endpoint: ['']
  });

  constructor(
    public dialogRef: MatDialogRef<ServerFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    private serverService: ServiceService
  ) {
    this.authService.getUser().subscribe(user => {
      this.loggedInUser = user;
    });
  }

  ngOnInit(): void {
    if (this.data) {
      this.serverForm.patchValue({
        id: this.data.id,
        name: this.data.name,
        environment: this.data.environment,
        url: this.data.url,
        port: this.data.port,
        user: EncryptionHandler.decryptToAES256(this.data.user),
        password: EncryptionHandler.decryptToAES256(this.data.password),
        endpoint: this.data.endpoint,
      });

      this.title = 'Update Server';
    }
  }

  save() {
    let server: Server = this.serverForm.value;
    server.owner = this.loggedInUser.id;
    server.user = EncryptionHandler.encryptToAES256(this.serverForm.value.user);
    server.password = EncryptionHandler.encryptToAES256(this.serverForm.value.password);

    if (!server.id)
      this.addServer(server);
    else
      this.updateServer(server);
  }

  addServer(server: Server) {
    this.loading = true;
    this.serverService.add(server)
      .then(() => {
        this.snackBar.open('Server added.', 'OK', { duration: 2000 });
        this.dialogRef.close(true);
        this.loading = false;
      })
      .catch(() => {
        this.snackBar.open('Error on submiting the server.', 'OK', { duration: 2000 });
        this.loading = false;
      });
  }

  updateServer(server: Server) {
    this.loading = true;
    this.serverService.update(server)
      .then(() => {
        this.snackBar.open('Server updated.', 'OK', { duration: 2000 });
        this.dialogRef.close(true);
        this.loading = false;
      })
      .catch(() => {
        this.snackBar.open('Error updating the server.', 'OK', { duration: 2000 });
        this.loading = false;
      });
  }

}
